import { bookService, projectService, attachmentService } from '@/services'
import { seventh, eighth, ninth, tenth, eleventh, twelfth } from './defaultTeamProjects'
import { generateHTML } from '@/core/helper-functions'

const tenthImage = {
  url: 'https://production-eu-uploads.s3.eu-central-1.amazonaws.com/190245/4372/1615145545564_2549447269795358.png',
  name: 'tenth.png',
  type: 'image/png'
}

const eleventhImages = [
  {
    url: 'https://production-eu-uploads.s3.eu-central-1.amazonaws.com/196654/36451/1631279625151_25963760237540.svg',
    name: 'first.svg',
    type: 'image/svg+xml'
  },
  {
    url: 'https://production-eu-uploads.s3.eu-central-1.amazonaws.com/196654/36451/1631483699251_230037860859670.svg',
    name: 'second.svg',
    type: 'image/svg+xml'
  },
  {
    url: 'https://production-eu-uploads.s3.eu-central-1.amazonaws.com/196654/36451/1631542528707_288867316051526.png',
    name: 'third.png',
    type: 'image/png'
  }
]

const twelfthImages = [
  {
    url: 'https://production-eu-uploads.s3.eu-central-1.amazonaws.com/196654/31586/1631138215371_137226599440085.svg',
    name: 'first.svg',
    type: 'image/svg+xml'
  },
  {
    url: 'https://production-eu-uploads.s3.eu-central-1.amazonaws.com/196654/31586/1631138469764_110467322646241.svg',
    name: 'second.svg',
    type: 'image/svg+xml'
  }
]

export default async (commit, settings) => {
  // create book
  const book = await bookService.create({
    title: 'Marketing',
    subTitle: 'Everything marketing. Superstars allowed only',
    color: 'blue'
  })

  // create seventh project
  const seventhProject = await projectService.add({
    bookId: book.data.dataValues.id,
    title: 'Welcome!',
    icon: 'purple_circle',
    parentId: null,
    body: seventh(),
    html: generateHTML(seventh(), settings, 'Welcome!')
  })

  commit('loading', true)

  // create eighth project
  await projectService.add({
    bookId: book.data.dataValues.id,
    title: 'Onboarding',
    icon: 'sailboat',
    parentId: seventhProject.data.dataValues.id,
    body: eighth(),
    html: generateHTML(eighth(), settings, 'Onboarding')
  })

  commit('loading', true)

  // create ninth project
  const ninthProject = await projectService.add({
    bookId: book.data.dataValues.id,
    title: 'Newsletters',
    icon: 'newspaper-emoji',
    parentId: null,
    body: ninth(),
    html: generateHTML(ninth(), settings, 'Newsletters')
  })

  commit('loading', true)

  // create tenth project
  const tenthProject = await projectService.add({
    bookId: book.data.dataValues.id,
    title: 'Welcome email',
    icon: 'keycap-digit-one',
    parentId: ninthProject.data.dataValues.id,
    body: tenth(),
    html: generateHTML(tenth(), settings, 'Welcome email')
  })

  commit('loading', true)

  const { data } = await attachmentService.proxy(tenthImage.url)

  const file = new File([data], tenthImage.name, { type: tenthImage.type })

  const formData = new FormData()
  formData.append('data', file, tenthImage.name)

  commit('loading', true)

  const response = await attachmentService.upload({
    projectId: tenthProject.data.dataValues.id,
    data: formData
  })

  const uploadedTenthImage = {
    id: response.data.id,
    url: response.data.url
  }

  commit('loading', true)

  await projectService.edit(
    ninthProject.data.dataValues.id,
    {
      title: 'Newsletters',
      body: ninth({
        bookId: book.data.dataValues.id,
        projectId: tenthProject.data.dataValues.id
      }),
      html: generateHTML(ninth({
        bookId: book.data.dataValues.id,
        projectId: tenthProject.data.dataValues.id
      }), settings, 'Newsletters')
    }
  )

  await projectService.edit(
    tenthProject.data.dataValues.id,
    {
      title: 'Welcome email',
      body: tenth(uploadedTenthImage),
      html: generateHTML(tenth(uploadedTenthImage), settings, 'Welcome email')
    }
  )

  // create eleventh project
  const eleventhProject = await projectService.add({
    bookId: book.data.dataValues.id,
    title: 'Public relations',
    icon: 'kiwi-fruit',
    parentId: null,
    body: eleventh(),
    html: generateHTML(eleventh(), settings, 'Public relations')
  })

  const uploadedEleventhImages = {}

  for (const image of eleventhImages) {
    commit('loading', true)

    const { data } = await attachmentService.proxy(image.url)

    const file = new File([data], image.name, { type: image.type })

    const formData = new FormData()
    formData.append('data', file, image.name)

    commit('loading', true)

    const response = await attachmentService.upload({
      projectId: eleventhProject.data.dataValues.id,
      data: formData
    })

    uploadedEleventhImages[image.name] = {
      id: response.data.id,
      url: response.data.url
    }
  }

  commit('loading', true)

  await projectService.edit(
    eleventhProject.data.dataValues.id,
    {
      title: 'Public relations',
      body: eleventh(uploadedEleventhImages),
      html: generateHTML(eleventh(uploadedEleventhImages), settings, 'Public relations')
    }
  )

  // create twelfth project
  const twelfthProject = await projectService.add({
    bookId: book.data.dataValues.id,
    title: 'Concept ads',
    icon: 'exploding-head',
    parentId: null,
    body: twelfth(),
    html: generateHTML(twelfth(), settings, 'Concept ads')
  })

  const uploadedTwelfthImages = {}

  for (const image of twelfthImages) {
    commit('loading', true)

    const { data } = await attachmentService.proxy(image.url)

    const file = new File([data], image.name, { type: image.type })

    const formData = new FormData()
    formData.append('data', file, image.name)

    commit('loading', true)

    const response = await attachmentService.upload({
      projectId: twelfthProject.data.dataValues.id,
      data: formData
    })

    uploadedTwelfthImages[image.name] = {
      id: response.data.id,
      url: response.data.url
    }
  }

  commit('loading', true)

  await projectService.edit(
    twelfthProject.data.dataValues.id,
    {
      title: 'Concept ads',
      body: twelfth(uploadedTwelfthImages),
      html: generateHTML(twelfth(uploadedTwelfthImages), settings, 'Concept ads')
    }
  )
}
